<template>
  <div class="home">
    <div class="header">
      <div class="user" @click="showUserinfo()">
        <img ref="img" :src="userHeander" alt="" class="head" />
        <span>{{ userName }}</span>
      </div>
      <div class="right">
        <div class="teacher" @click="showTeacherVisible = true">
          <img src="@/assets/images/teacher.png" alt />
          <p>班主任</p>
        </div>
        <div class="public" @click="showPublicVisible = true">
          <img src="@/assets/images/public.png" alt />
          <p>公众号</p>
        </div>
      </div>
    </div>
    <div class="Units">
      <Units
        :serverDate="serverDate"
        :package="showPackage"
        @setIframeSrc="setIframeSrc"
        @showTest="showTest"
        @showUserinfo="showUserinfo"
      />
    </div>
    <div class="scratchIframe" v-show="iframeSrc != ''">
      <p class="back" @click="backMain">返回</p>
      <iframe :src="iframeSrc"></iframe>
    </div>
    <div class="footer">
      <div class="packages" @click="choicePackage">
        <img src="@/assets/images/packages.png" alt />
        <p>选择课程</p>
      </div>
      <div class="footer-tab">
        <p class="p-left"><span></span>我的课程</p>
        <p class="p-right" @click="showWorks">我的作品</p>
      </div>
    </div>
    <!--班主任dialog -->
    <RightTwoDialog
      v-show="showTeacherVisible"
      @close="close"
      :showPackage="showPackage"
      :title="teacher"
      :content="teacherContent"
    />
    <!--公众号dialog -->
    <RightTwoDialog
      v-show="showPublicVisible"
      @close="close"
      :showPackage="showPackage"
      :title="publicTitle"
      :publicBottom="publicBottom"
      :content="publicContent"
    />
    <!-- 个人信息dialog -->
    <Userinfo
      v-show="showUserinfoVisible"
      @close="close"
      @getUserinfo="getUserinfo"
      @userrefresh="userRefresh"
    />
    <Test v-show="testBoxShow" @closeTestBox="closeTestBox" />
    <!-- 二维码激活 -->
    <PackagesDialog
      v-show="showPackagesCode"
      @close="close"
      :title="qrTitle"
      :content="qrContent"
      :code="qrcodeUrl"
    />

    <!-- 21-5-24 add -->
    <div v-show="isLookat" class="newBox">
      <div class="newBox-inner">
        <img src="../assets/images/lock.png" alt="" />
        <div>抱歉，该课程尚未解锁！</div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Units from "@/components/home/Units.vue";
import Userinfo from "../components/Userinfo"; // 个人信息组件
import RightTwoDialog from "../components/RightTwoDialog"; // 右边的组件
import Test from "../components/test";
import PackagesDialog from "../components/packagesDialog"; // 右边的组件

export default {
  name: "home",
  data() {
    return {
      allPackages: [],
      showPackage: {},
      iframeSrc: "",
      nowPackageId: "",
      timer: "",
      userName: "",
      userHeander: "",
      testBoxShow: false,
      showPackagesCode: false,
      showTeacherVisible: false,
      showPublicVisible: false,
      showUserinfoVisible: false,
      teacher: "班主任",
      teacherContent: "班主任会反馈学情，也会竭力解答您的所有疑问。",
      teacherCode: "",
      publicTitle: "关注公众号",
      publicBottom: "极客晨星编程课堂",
      publicContent: "激活上课账号 / 查看和分享作业 / 参与优惠活动",
      publicCode: "",
      qrTitle: "关注公众号",
      qrContent: "激活上课账号 / 查看和分享作业 / 参与优惠活动",
      qrcodeUrl: "",
      pageId: "",
      stopProbe: false,
      serverDate: "",
      // 21-5-24 add
      isLookat: false,
    };
  },
  components: {
    Units,
    Userinfo,
    RightTwoDialog,
    Test,
    PackagesDialog,
  },
  mounted() {
    this.getAllPackages();
    this.userRefresh();
    this.timer = setInterval(() => {
      this.getAllPackages();
    }, 60000);

    this.axios
      .get('/assox?update="update"')
      .then((res) => {
        this.qrcodeUrl = res.data.qrcode;
        this.pageId = res.data.pageId;
        this.probe();
      })
      .catch((error) => {
        console.log("error", error);
      });
    this.axios.get("/v1/api/self").then((res) => {
      this.showPackagesCode = !res.data.user.wechat ? true : false;
    });
  },
  methods: {
    probe() {
      this.axios
        .get(`/probe/${this.pageId}`, { timeout: 5000 })
        .then((res) => {
          this.showPackagesCode = false;
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else {
            if (this.showPackagesCode) {
              setTimeout(this.probe, 0);
            }
          }
        });
    },
    userRefresh() {
      this.axios
        .get("/v1/api/self")
        .then((res) => {
          this.userHeander = res.data.user.avatar + "?" + Math.random();
          if (res.data.user.nickname == undefined) {
            this.userName = res.data.user.name;
          } else {
            this.userName = res.data.user.nickname;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showTest() {
      this.testBoxShow = true;
    },
    closeTestBox(arg) {
      this.testBoxShow = arg;
    },
    getAllPackages() {
      if (this.$route.query.packageId) {
        this.nowPackageId = this.$route.query.packageId;
        this.axios
          .get(`/v1/api/self/scratch/packages/${this.nowPackageId}`)
          .then((res) => {
            if (
              res.data.package.lock &&
              res.data.package.lock.lockType === "forever"
            ) {
              this.isLookat = true;
            } else {
              this.isLookat = false;
            }
            this.serverDate = res.headers.date;
            this.showPackage = res.data.package;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.axios
          .get("/v1/api/self/scratch/packages")
          .then((res) => {
            this.serverDate = res.headers.date;
            this.allPackages = res.data.packages;
            this.getPackage();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getPackage() {
      if (this.allPackages.length <= 0) {
        console.log("当前用户没有课程包");
        return;
      }
      let theFirst = null;
      this.allPackages.forEach((item) => {
        if (item.type === "scratch/archived") {
          theFirst = item;
        }
      });
      if (theFirst) {
        let firstId = theFirst._id;
        this.nowPackageId = firstId;
        this.axios
          .get(`/v1/api/self/scratch/packages/${firstId}`)
          .then((res) => {
            if (
              res.data.result === "failure" &&
              res.data.package.lock &&
              res.data.package.lock.type === "forever"
            ) {
              this.isLookat = true;
            } else {
              this.allPackages.forEach((item) => {
                if (item._id === res.data.package._id) {
                  if (item.lock && item.lock.lockType === "forever") {
                    this.isLookat = true;
                  } else {
                    this.isLookat = false;
                  }
                }
              });
              this.showPackage = res.data.package;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    setIframeSrc(src) {
      this.iframeSrc = src;
    },
    backMain() {
      this.iframeSrc = "";
    },
    showWorks() {
      this.$router.push({
        path: "/worklist",
        query: { nowPackageId: this.nowPackageId },
      });
    },
    getUserinfo(arg) {
      this.name = arg;
    },
    goChooseCourses() {
      this.$router.push("/chooseCourses");
    },
    showTeacher() {
      this.showTeacherVisible = true;
    },
    showPublic() {
      this.showPublicVisible = true;
    },
    showUserinfo() {
      this.showUserinfoVisible = true;
    },
    close(arg) {
      this.showUserinfoVisible = arg;
      this.showTeacherVisible = arg;
      this.showPublicVisible = arg;
      this.showPackagesCode = false;
    },
    choicePackage() {
      this.$router.push({
        path: "packages",
        query: { packageId: this.nowPackageId },
      });
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.stopProbe = true;
  },
};
</script>

<style lang="stylus" scoped>
.home {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #E5FFED;
  min-width: 1200px;
  min-height: 650px;
  overflow: hidden;
  -webkit-user-select: none;

  .header {
    display: flex;
    color: #fff;
    justify-content: space-between;
    padding-top: 29px;

    .user {
      width: 220px;
      height: 70px;
      line-height: 70px;
      background-image: url('~@/assets/images/username-bg.png');
      background-size: 100% 100%;
      font-size: 20px;
      font-weight: 500;
      margin-left: 40px;
      cursor: pointer;
      display: flex;
      justify-content: flex-end;
      position: relative;

      .head {
        width: 61px;
        height: 61px;
        position: absolute;
        left: 4px;
        top: 3px;
        background: #fff;
        border-radius: 50%;
      }

      span {
        width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        overflow: hidden;
      }
    }

    .right {
      display: flex;

      .teacher, .public {
        font-size: 15px;
        color: #565656;
        margin-right: 32px;
        cursor: pointer;

        img {
          width: 60px;
          height: 60px;
        }

        p {
          text-align: center;
          margin-top: 5px !important;
        }
      }
    }
  }

  .Units {
    width: 100%;
    height: 450px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
  }

  .scratchIframe {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;

    iframe {
      width: 100%;
      height: 100%;
    }

    .back {
      position: absolute;
      left: 10px;
      top: 10px;
      width: 100px;
      height: 100px;
      background: yellow;
    }
  }

  .footer {
    width: 100%;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 50px;

    .packages {
      font-size: 15px;
      color: #565656;
      margin-right: 32px;
      position: absolute;
      left: 40px;
      bottom: -20px;
      cursor: pointer;

      img {
        width: 60px;
        height: 60px;
      }

      p {
        text-align: center;
        margin-top: 5px !important;
      }
    }

    .footer-tab {
      width: 296px;
      height: 48px;
      background: rgba(28, 204, 255, 1);
      border-radius: 40px;
      box-shadow: 0px 4px 3px #00AEE1;
      padding: 3px;
      display: flex;
      cursor: pointer;

      p {
        font-size: 20px;
        color: #fff;
        width: 165px;
        height: 49px;
        text-align: center;
        line-height: 52px;
        font-weight: 600;
        text-shadow: 0px 1px 3px rgba(220, 127, 0, 0.6);

        span {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 3px 0px rgba(0, 109, 220, 0.6);
          margin: 3px 10px;
        }
      }

      .p-left {
        background: linear-gradient(132deg, rgba(255, 220, 74, 1) 0%, rgba(253, 182, 36, 1) 100%);
        border-radius: 36px 0px 0px 36px;
        box-shadow: 0px 2px 3px 0px rgba(0, 109, 220, 0.6);
      }
    }
  }
}

.newBox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  z-index: 9999;
}

.newBox .newBox-inner {
  width: 500px;
  height: 300px;
  background-color: #bbb4b4;
  margin: auto;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.newBox-inner > div {
  margin-top: 25px;
  color: #FFF;
}
</style>
